<template lang="pug">
  section.advantage(id="advantage")
    h1(:class="titleAnimation") {{ nowOps.advantagesTitle }}
    div.content
      div.contentItem(v-for="(item, index) in nowOps.advantagesList"
        :class="[contentAnimation, `animateDelay-${index}`, nowOps.advantageClass]")
        img(:src="item.img")
        p {{ item.text }}
</template>

<script>
  import Mixin from '../index.js'
  
  export default {
    name: "advantage",
    mixins: [Mixin],
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .advantage {
    VStack(center)
    padding 100px 0
    width 100%
    > .content {
      HStack(center, center)
      flex-wrap wrap
      margin 0 18.75%
      margin-top -30px
      .contentItem {
        HStack(center, center)
        width 30%
        margin-top 30px
        img {
          height 100px
          width 100px
          margin-left 46px
          margin-right 30px
        }
        p {
          font-size 16px
          FontSetting("思源黑体")
          font-weight 300
          color #202020
          line-height 24px
          width 308px
        }
      }
      .vstack {
        VStack(center, center)
        img {
          margin 0
        }
        p {
          text-align center
        }
      }
      .twoItemPerRow {
        width 50%
      }
    }
    @media (max-width ipadProScreenWidth) {
      h1 {
        padding 0 50px
      }
      > .content {
        margin 0 auto
      }
    }
  
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      max-width 100vw
      .content {
        width 100vw
      }
    }
    
    @media (max-width 960px) {
      .content {
        .contentItem {
          VStack(center)
          p {
            text-align center
          }
        }
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      h1 {
        margin-bottom 0
      }
      .content {
        HStack()
        margin 0
        .contentItem {
          width 50%
          VStack(center)
          img {
            width 60px
            height auto
            margin 0
            margin-right 8px
          }
          p {
            padding 0 20px
            width calc(100% - 40px)
            white-space pre-wrap
            font-size 14px
            text-align center
          }
        }
      }
    }
  }
</style>
